import { Button, Popover, PopoverBody } from "reactstrap";
import { Link } from "react-router-dom";
import emojis, { passIcons, defaultEmojiImage } from "../data/emoji";
import { useAuth } from "./AuthProvider";
import { useState, useEffect } from "react";
import { getUserProfile } from "../service/auth";
import ChangeEmojiModal from "./ChangeEmojiModal";

function ProfilePopover() {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState(null);
  const [hasPartyPass, setHasPartyPass] = useState(false);
  const [isBouncing, setIsBouncing] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const { authDetails, logout, updateUserProfile } = useAuth();

  // Listen for star animation to trigger emoji bounce
  useEffect(() => {
    const handleStarAdded = () => {
      setIsBouncing(true);
      setTimeout(() => setIsBouncing(false), 500);
    };

    window.addEventListener('starAddedToLibrary', handleStarAdded);
    return () => window.removeEventListener('starAddedToLibrary', handleStarAdded);
  }, []);

  useEffect(() => {
    // Fetch user profile to get the email, id, and pass type
    const fetchUserProfile = async () => {
      try {
        const response = await getUserProfile();
        console.log("ProfilePopover - Full API Response:", response);
        console.log("ProfilePopover - Response Data:", response.data);

        // Try both possible structures
        const email = response.data?.email || response.data?.data?.email || "";
        const id = response.data?.id || response.data?.data?.id || null;
        const zebraId = response.data?.zebra_id || response.data?.data?.zebra_id || null;

        setUserEmail(email);
        setUserId(id);
        setHasPartyPass(!!zebraId);

        // Sync to AuthContext so other parts of the app have access
        updateUserProfile({ id, zebra_id: zebraId });
      } catch (error) {
        console.error("Failed to fetch user profile:", error);
      }
    };

    if (authDetails.emoji) {
      fetchUserProfile();
    }
  }, [authDetails.emoji]);

  const profileEmojiPath = authDetails?.emoji
    ? emojis.find((emoji) => emoji.name === authDetails.emoji)?.src || defaultEmojiImage
    : defaultEmojiImage;

  return authDetails.emoji || authDetails.isAuthenticated ? (
    <div className="profile-popover-container">
      <Button
        id="profilePopver"
        type="button"
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        className="profile-emoji-btn"
      >
        <img
          src={profileEmojiPath}
          alt="User Emoji"
          className={`profile-emoji ${isBouncing ? 'emoji-bounce' : ''}`}
        />
      </Button>
      <Popover
        target="profilePopver"
        isOpen={isPopoverOpen}
        placement="bottom-start"
        popperClassName="profile-popover-wrapper"
        trigger="legacy"
        flip
        toggle={() => setIsPopoverOpen(!isPopoverOpen)}
      >
        <PopoverBody>
          <button
            type="button"
            onClick={() => {
              setShowEmojiPicker(true);
              setIsPopoverOpen(false);
            }}
            style={{
              background: 'none',
              border: 'none',
              padding: '8px 0',
              marginBottom: '8px',
              color: '#fed53b',
              fontSize: '18px',
              fontFamily: 'EagleBold, sans-serif',
              textDecoration: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'all 0.3s ease'
            }}
          >
            Change Emoji
          </button>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '8px',
            color: '#000',
            fontSize: '20px',
            fontFamily: 'EagleBold, sans-serif'
          }}>
            {hasPartyPass ? 'Party Pass' : 'Basic Pass'}
            <img
              src={hasPartyPass ? passIcons.party : passIcons.basic}
              alt={hasPartyPass ? 'Party Pass' : 'Basic Pass'}
              style={{ width: '30px', height: '30px' }}
            />
          </div>
          {userId && (
            <div style={{
              marginBottom: '8px',
              color: '#000',
              fontSize: '20px',
              fontFamily: 'EagleBold, sans-serif'
            }}>
              Pass #: {userId}
            </div>
          )}
          {!hasPartyPass && (
            <button
              type="button"
              onClick={() => {
                window.open('https://buy.stripe.com/28E8wPe4Q85V87z5yRgfu01', '_blank');
                setIsPopoverOpen(false);
              }}
              style={{
                display: 'block',
                width: '100%',
                padding: '12px 24px',
                marginBottom: '8px',
                color: '#fff',
                fontSize: '18px',
                fontFamily: 'EagleBold, sans-serif',
                textDecoration: 'none',
                background: 'linear-gradient(145deg, #ff71ee, #e050d6)',
                border: '2px solid #ff71ee',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                textAlign: 'center'
              }}
            >
              Upgrade
            </button>
          )}
          <Link
            to="/library"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '8px 0',
              marginBottom: '8px',
              borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
              color: '#fed53b',
              fontSize: '20px',
              fontFamily: 'EagleBold, sans-serif',
              textDecoration: 'none'
            }}
            onClick={() => setIsPopoverOpen(false)}
          >
            <span>My Library</span>
            <span style={{ fontSize: '30px' }}>⭐</span>
          </Link>
          <button
            type="button"
            onClick={() => {
              setIsPopoverOpen(false);
              logout();
            }}
            style={{
              display: 'block',
              width: '100%',
              background: 'none',
              border: 'none',
              padding: '8px 0',
              marginBottom: '8px',
              fontFamily: 'EagleBold, sans-serif',
              color: '#000',
              fontSize: '20px',
              cursor: 'pointer',
              textDecoration: 'none',
              textAlign: 'left',
              transition: 'all 0.3s ease'
            }}
          >
            Logout
          </button>
          {userEmail && (
            <div style={{
              padding: '8px 0',
              color: '#000',
              fontSize: '20px',
              fontFamily: 'EagleBold, sans-serif',
              wordBreak: 'break-word'
            }}>
              {userEmail}
            </div>
          )}
        </PopoverBody>
      </Popover>
      <ChangeEmojiModal
        isOpen={showEmojiPicker}
        onClose={() => setShowEmojiPicker(false)}
      />
    </div>
  ) : (
    <></>
  );
}

export default ProfilePopover;
